import { ref } from "vue";
import { NgGameDefinition } from "../model/ng-game-definition";
import { type OnlineGameDetail } from "../model/online-game-detail";

/** ID of currently opened game */
const currentGameId = ref(0);

/** Flag if user plays for money */
const playForMoney = ref(false);
/** Flag if transparent game is being opened */
const transparentGame = ref(false);

// Revert changes from FE-4801 only for games
const netLoss = ref<number | null>(null);

const sessionStart = ref<number | null>(null);

const currentGameServerData = ref<OnlineGameDetail | null>(null);

const ngGameDefinition = ref<NgGameDefinition | null>(null);

/** Temporary feature flag before app releases version supporting game layer features */
const areGameLayerFeaturesHiddenInApp = ref(false);

/** URL to redirect to when closing the game layer (the page user came from) */
const returnUrl = ref<string | null>(null);

export const useNgCasinoState = () => {
    return {
        currentGameId,
        playForMoney,
        transparentGame,
        netLoss,
        sessionStart,
        currentGameServerData,
        ngGameDefinition,
        areGameLayerFeaturesHiddenInApp,
        returnUrl,
    };
};
